import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const StageDeliverReleaseModal = ({ apiUrl, release, onClose, onDelivered }) => {
  const [deliveredDate, setDeliveredDate] = useState(new Date().toISOString().slice(0, 10));
  const [deliveredBy, setDeliveredBy] = useState('');
  const [destinationName, setDestinationName] = useState(release?.destination_name || '');
  const [notes, setNotes] = useState(release?.notes || '');
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!release?.id) return;

    const payload = {
      release_id: Number(release.id),
      delivered_date: deliveredDate,
      delivered_by: deliveredBy?.trim() || null,
      destination_name: destinationName?.trim() || null,
      notes: notes?.trim() || null,
    };

    setSaving(true);
    try {
      const res = await axios.post(
        `${apiUrl}/inventory_crud.php`,
        { status: 'deliverStagingRelease', data: payload },
        { headers: { 'Content-Type': 'application/json' } }
      );

      const ok =
        (res.data && res.data.success === true) ||
        (Array.isArray(res.data) && res.data[0] === 'success');

      if (ok) {
        toast.success('Marked as Delivered');
        onDelivered?.();
        onClose();
      } else {
        toast.error(res.data?.error || 'Failed to deliver');
      }
    } catch (e2) {
      toast.error('API error delivering release');
    } finally {
      setSaving(false);
    }
  };

  if (!release) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white w-full max-w-xl rounded-lg shadow-lg">
        <div className="px-5 py-4 border-b flex items-center justify-between">
          <h2 className="text-lg font-semibold">Deliver Release #{release.id}</h2>
          <button
            className="text-gray-500 hover:text-gray-700"
            onClick={onClose}
            type="button"
          >
            ✕
          </button>
        </div>

        <form onSubmit={submit} className="p-5 space-y-4">
          <div className="text-sm bg-gray-50 border rounded p-3">
            <div>
              <span className="text-gray-500">Item:</span>{' '}
              <b>{release.device || `#${release.device_id}`}</b>
            </div>
            {release.description && (
              <div className="text-gray-500">{release.description}</div>
            )}
            <div className="mt-1">Released Qty: <b>{release.released_quantity}</b></div>
            <div>Status: <b>{release.status}</b></div>
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Delivered Date</label>
            <input
              type="date"
              className="w-full border rounded px-3 py-2"
              value={deliveredDate}
              onChange={(e) => setDeliveredDate(e.target.value)}
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Delivered By</label>
            <input
              className="w-full border rounded px-3 py-2"
              value={deliveredBy}
              onChange={(e) => setDeliveredBy(e.target.value)}
              placeholder="Leave blank to use logged-in user"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Destination Name</label>
            <input
              className="w-full border rounded px-3 py-2"
              value={destinationName}
              onChange={(e) => setDestinationName(e.target.value)}
              placeholder="e.g., Jobsite A"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Notes</label>
            <textarea
              rows={3}
              className="w-full border rounded px-3 py-2"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Optional notes…"
            />
          </div>

          <div className="flex items-center justify-end gap-2 pt-2">
            <button
              type="button"
              className="px-4 py-2 rounded border"
              onClick={onClose}
              disabled={saving}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded disabled:opacity-60"
              disabled={saving}
            >
              {saving ? 'Saving…' : 'Mark Delivered'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default StageDeliverReleaseModal;
